/**
 * <recently-viewed>: the "נצפו לאחרונה" list on the product page.
 *
 * Rewritten readable from the theme's one-line build on 2026-09-05 to add one
 * behaviour the theme lacks: the product you are standing on is never in its
 * own recently-viewed list.
 *
 * Why it leaked: Shopify.Products.recordRecentlyViewed (theme.js) runs on every
 * product page and puts the CURRENT handle at the front of the cookie queue,
 * and showRecentlyViewed then renders the queue from the front. So slot one
 * was always the page itself. theme.js is a build artefact and is not edited,
 * so the fix lives here: ask for one card more than the limit, drop the card
 * that is this page, then trim back to the limit if nothing was dropped.
 *
 * The public contract is unchanged: 'theme:recently-viewed:loaded' fires once
 * the list is final, which is what related-products.js waits on before it
 * shows the tab and initialises the slider.
 */
(function () {
  'use strict';

  var SECTION = '[data-section-id]';
  var CARD = '[data-grid-item], .grid-item';

  if (customElements.get('recently-viewed')) return;

  function handleFromUrl(url) {
    if (!url) return '';
    var m = url.split('?')[0].split('/products/');
    return m.length > 1 ? decodeURIComponent(m[1]).replace(/\/+$/, '') : '';
  }

  customElements.define('recently-viewed', class extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest(SECTION);
      this.howManyToShow = parseInt(this.dataset.limit, 10) || 3;
      this.target = this.dataset.target;
      this.wrapperId = this.dataset.wrapperId || this.id;
      // The page's own handle, from the snippet when it knows it, otherwise
      // from the URL. Handles are Hebrew here, hence the decode.
      this.currentHandle = this.dataset.currentHandle || handleFromUrl(window.location.pathname);
    }

    connectedCallback() {
      var self = this;
      if (!window.Shopify || !Shopify.Products) return;
      Shopify.Products.showRecentlyViewed({
        howManyToShow: this.howManyToShow + (this.currentHandle ? 1 : 0),
        wrapperId: this.wrapperId,
        section: this.section,
        target: this.target,
        onComplete: function () {
          self.dropCurrentProduct();
          self.dispatchEvent(new CustomEvent('theme:recently-viewed:loaded', { bubbles: false }));
        }
      });
    }

    dropCurrentProduct() {
      var wrapper = document.getElementById(this.wrapperId);
      if (!wrapper) return;
      var cards = Array.prototype.slice.call(wrapper.querySelectorAll(CARD));
      var me = this.currentHandle;

      if (me) {
        cards.forEach(function (card) {
          var url = card.getAttribute('data-url') || (card.querySelector('a[href*="/products/"]') || {}).getAttribute && card.querySelector('a[href*="/products/"]').getAttribute('href');
          if (handleFromUrl(url) === me) card.remove();
        });
      }

      // We asked for one extra to cover the drop; if the page was not in the
      // list (or was recorded late), give the extra back.
      cards = Array.prototype.slice.call(wrapper.querySelectorAll(CARD));
      while (cards.length > this.howManyToShow) {
        cards.pop().remove();
      }
    }
  });
})();
